// extracted by mini-css-extract-plugin
module.exports = {"dbIframe":"cd_m3","dbIframe__loader":"cd_m4","dbIframe__loaderExcel":"cd_m5","dbIframe__loaderLoading":"cd_m6","dbIframe_isLoaded":"cd_m7","dbIframe__iframe":"cd_m8"};